<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}课程`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="课程名称">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                 <el-form-item label="编程语言">
                    <el-select v-model="form.type" placeholder="编程语言">
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签">
                    <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>
                </el-form-item>
                <el-form-item label="ppt是否学生可见">
                    <el-switch v-model="form.pptStudentVisible"
                               inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="封面">
                    <el-upload
                        class="photo_uploader"
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="uploadCover">
                        <img v-if="form.coverImg != null" :src="form.coverImg" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>

                </el-form-item>

                <el-form-item label="教师视频">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :limit="1"
                        :multiple="false"
                        accept="video/mp4"
                        :on-remove="removeVideo"
                        :before-upload="uploadVideo"
                        :file-list="form.videos">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">
                            只能上传一个mp4格式视频文件，且不超过{{num}}M。注意视频必须是H.264编码的，否则可能无法在线播放
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="演示代码">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :limit="1"
                        :multiple="false"
                        :on-remove="removeCode"
                        :file-list="form.codes">
                        <el-button size="small" type="primary" @click.stop="setLessonCode(form)">
                            {{form.codes[0] ? "重新编辑" : "去编辑"}}
                        </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="教师PPT">
                    <el-upload
                        class="upload-demo"
                        action=""
                        accept="application/vnd.ms-powerpoint"
                        :on-remove="removePpt"
                        :before-upload="uploadPpt"
                        multiple
                        :file-list="form.ppts">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传PPT格式文件，且不超过{{num}}M。</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="教师教案">
                    <el-upload
                        class="upload-demo"
                        action=""
                        accept="text/plain,application/zip,application/rar,application/vnd.ms-powerpoint,application/msword,application/vnd.ms-excel,application/pdf"
                        :on-remove="removePlan"
                        :before-upload="uploadPlan"
                        multiple
                        :file-list="form.plans">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传压缩文件或者Office、Pdf文档，且不超过{{num}}M。</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label="简介">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="form.introduction"
                        maxlength="255"
                        :rows="5"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>

            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="sub()">保存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .task {
        border-radius: 6px;
        border: 1px solid var(--border);
        min-height: 40px;
        position: relative;
        padding: 20px;
    }

    .task_close {
        position: absolute;
        right: 10px;
        top: 10px;
        color: var(--lighter);
        cursor: pointer;
        font-size: 20px;
    }

    .task_close:hover {
        color: var(--primary);
    }

    .task_form {
        width: 80%;
    }

</style>


<script>

    import {mapMutations} from "vuex";
    export default {
        props: [
            "item",
            "showBox",
        ],
        data() {
            return {
                show: false,
                form: {},
                lessonTypes: [],
                num:0,
            }

        },
        computed: {
        },
        watch: {
            "num":function () {
                console.log(this.num)
            },
        },

        methods: {
            ...mapMutations([
                "addStorageHandler",
                "removeStorageHandler",
            ]),
            uploadCover(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                this.$uploadQiniu(file, "lesson/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {coverImg: file.url,fileSize:fileSize});
                        }
                    }
                )

                return false;
            },
            uploadVideo(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > this.num) {
                    this.$showError("禁止上传超过"+this.num+"M大小文件");
                } else {
                    this.$uploadQiniu(file, "lesson/").then((file) => {
                        file.category = 1;
                        file.fileSize = fileSize;
                        this.$set(this.form.videos, 0, file);
                    })
                }
                return false;
            },
            removeVideo(file) {
                this.form.videos.splice(0, 1);
            },
            uploadPpt(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > this.num) {
                    this.$showError("禁止上传超过"+this.num+"M大小文件");
                } else {
                    this.$uploadQiniu(file, "lesson/").then((file) => {
                        file.category = 3;
                        file.fileSize = fileSize;
                        this.form.ppts.push(file);
                    })
                }
                return false;
            },
            removePpt(file) {
                this.form.ppts = this.form.ppts.filter(item => item.uid != file.uid);
            },
            uploadPlan(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                if (file.size / 1048576 > this.num) {
                    this.$showError("禁止上传超过"+this.num+"M大小文件");
                } else {
                    this.$uploadQiniu(file, "lesson/").then((file) => {
                        file.category = 2;
                        file.fileSize = fileSize;
                        this.form.plans.push(file);
                    })
                }
                return false;
            },
            removePlan(file) {
                this.form.plans = this.form.plans.filter(item => item.uid != file.uid);
            },
            setLessonCode(lesson) {
                // 临时字段，设置一个标识，拱多页面间数据共享用
                // 应该用id的，但是新增课程没有id，只能用这个了
                if (!lesson.caseFlag) {
                    lesson.caseFlag = new Date().getTime();
                }
                let key = "lesson_case_"+lesson.caseFlag;

                let _this = this;
                // let handler = function(event) {
                //     let data = event.data; //{type: "case_code", id:key, url:"七牛地址"}

                //     if(data.type == "case_code" && data.id == key) {
                //         console.debug("成功保存示例代码", data);
                //         _this.$showSuccess("检测到示例代码成功保存", 5000);
                //         let code = lesson.codes[0];
                //         if (code) {
                //             _this.$set(code, "url", data.url);
                //         } else {
                //             _this.$set(lesson.codes, 0, {category:4, url: data.url, name: "示例代码"});
                //         }

                //         window.removeEventListener("message",handler, false);
                //     }
                // }
                // /**
                //  * 跨域页面通信 处理，参考https://developer.mozilla.org/zh-CN/docs/Web/API/Window/postMessage
                //  * 目前主要是 课程任务的示例代码编辑
                //  */
                // window.addEventListener("message", handler, false)
                this.addStorageHandler({
                    key: key,
                    handler: (e) => {
                        if (e.key == key) {
                            console.debug("成功保存示例代码", e);
                            this.$showSuccess("检测到示例代码成功保存", 5000);
                            let code = lesson.codes[0];
                            if (code) {
                                this.$set(code, "url", e.newValue);
                            } else {
                                this.$set(lesson.codes, 0, {category:4, url: e.newValue, name: "示例代码"});
                            }

                        }
                    }
                })

                let codeUrl = lesson.codes[0] ? lesson.codes[0].url : "";
                localStorage.setItem(key, codeUrl)
                this.$goEditCode(this.form.type,"mode=case&id="+key);
                this.$showWarn("请到新打开的页面中编辑代码，编辑完成后点击上方的【保存代码】按钮", 5000);

            },
            removeCode() {
                this.form.codes.splice(0, 1);
            },
            close() {
                this.$emit("close");
            },
            sub() {
                let resources = [...this.form.videos, ...this.form.ppts, ...this.form.plans, ...this.form.codes];
                let data = {
                    ...this.form,
                    resources: resources
                }
                this.$ajaxPost("/lesson/saveByPrepare", {
                    lesson: data
                }, (data) => {
                    this.$emit("submit", data.result);
                })
            },
            analyseForm(item) {
                this.form = {
                    ...item,
                    videos: item.videos ? item.videos : [],
                    codes: item.codes ? item.codes : [],
                    ppts: item.ppts ? item.ppts : [],
                    plans: item.plans ? item.plans : []
                }
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            loadOneFileSizeLimit(){
                this.$ajaxGet("/schoolStrategt/getOneFileSizeLimit", (data) => {
                    this.num = data.result;
                })
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadOneFileSizeLimit();
            this.analyseForm(this.item);
            this.loadLessonTypes();
        },
        beforeDestroy() {
            //清除Storage回调处理
            if (this.form.caseFlag) {
                this.removeStorageHandler("lesson_case_"+this.form.caseFlag);
            }
        }

    }
</script>
